import type {UnfairPriceProduct} from '../../types';

import {Card} from '@ds/components';
import {numberFormat} from 'utils/Helper';

type UnfairPriceProductCardProps = {
  product: UnfairPriceProduct;
};

const UnfairPriceProductCard: React.FC<UnfairPriceProductCardProps> = ({product}) => {
  return (
    <Card size="small" className="w-full">
      <article className="flex items-center gap-3">
        <div className="flex size-20 shrink-0 items-center justify-center rounded-lg bg-gray-02 p-1">
          <img
            className="size-full object-contain mix-blend-multiply"
            src={product.image_url}
            alt={product.title ?? ''}
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <h2 className="text-body-sm-emphasis text-gray-09">{product.title}</h2>
          <div className="flex items-center justify-between gap-2 text-body-sm">
            <span className="text-gray-07">قیمت شما</span>
            <span className="text-body-sm-emphasis text-destructive">
              {numberFormat(product.actual_price ?? 0)} تومان
            </span>
          </div>
          <div className="flex items-center justify-between gap-2 text-body-sm">
            <span className="text-gray-07">قیمت مرجع</span>
            <span className="text-body-sm-emphasis text-gray-09">
              {numberFormat(product.expected_price ?? 0)} تومان
            </span>
          </div>
        </div>
      </article>
    </Card>
  );
};

export default UnfairPriceProductCard;
